module.exports = __webpack_public_path__ + "static/media/23.cd48054a.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/mouth/23.png
// module id = 805
// module chunks = 0